import { CaretRightOutlined } from "@ant-design/icons";
import React, { useMemo } from "react";
import _isEmpty from "lodash/isEmpty";

import SelectRoutes from "./SelectRoutes";
import "./ServiceType.scss";

const ServiceType = ({
  service,
  routes,
  setRoutes,
  estimatePriceOrganization,
  drivers,
  driversLoading
}) => {
  const { bulletPointOne, bulletPointTwo, bulletPointThree } = service;
  const queryParams = new URLSearchParams(window.location.search);
  const serviceId = queryParams.get("selectedService");
  const isSelectedService = service?.id === serviceId;

  // Check if service has manifest pricing enabled
  const hasManifestPricing = useMemo(() => {
    if (!service || !service.vehicleRates || !Array.isArray(service.vehicleRates)) {
      return false;
    }
    return service.vehicleRates.some((rate) => rate?.pricePerManifest > 0);
  }, [service]);

  // Count dropoffs without internalOrderId
  const dropoffsWithoutInternalOrderId = useMemo(() => {
    if (!hasManifestPricing || _isEmpty(routes)) return 0;

    let count = 0;
    const countedDropoffs = new Set(); // Track dropoffs we've already counted

    console.log("Routes object:", routes);
    Object.keys(routes).forEach((routeKey) => {
      const route = routes[routeKey];
      console.log(`Route ${routeKey}:`, route);
      if (route && route.jobs && Array.isArray(route.jobs)) {
        console.log(`Jobs in ${routeKey}:`, route.jobs);
        route.jobs.forEach((job) => {
          console.log("Job:", job);

          // Method 1: Check job.dropoff.internalOrderId (after optimization)
          if (job && job.dropoff) {
            const dropoffId = job.dropoff.id;
            const internalOrderId = job.dropoff.internalOrderId;
            console.log("Job dropoff:", job.dropoff, "internalOrderId:", internalOrderId);

            if (!countedDropoffs.has(dropoffId)) {
              // Check if internalOrderId is missing, null, undefined, or empty string
              if (
                !internalOrderId ||
                (typeof internalOrderId === "string" && internalOrderId.trim() === "")
              ) {
                count++;
                countedDropoffs.add(dropoffId);
                console.log("Count incremented to:", count, "for dropoff:", dropoffId);
              }
            }
          }

          // Method 2: Check packages[].dropoffs[] array (before optimization)
          if (job && job.packages && Array.isArray(job.packages)) {
            job.packages.forEach((pack) => {
              console.log("Package:", pack);
              if (pack.dropoffs && Array.isArray(pack.dropoffs)) {
                console.log("Package dropoffs:", pack.dropoffs);
                pack.dropoffs.forEach((dropoff) => {
                  const dropoffId = dropoff.id;
                  const internalOrderId = dropoff.internalOrderId;
                  console.log(
                    "Dropoff from package:",
                    dropoff,
                    "internalOrderId:",
                    internalOrderId
                  );

                  if (!countedDropoffs.has(dropoffId)) {
                    // Check if internalOrderId is missing, null, undefined, or empty string
                    if (
                      !internalOrderId ||
                      (typeof internalOrderId === "string" &&
                        internalOrderId.trim() === "")
                    ) {
                      count++;
                      countedDropoffs.add(dropoffId);
                      console.log(
                        "Count incremented to:",
                        count,
                        "for dropoff:",
                        dropoffId
                      );
                    }
                  }
                });
              }
            });
          }
        });
      }
    });

    console.log("Final count:", count);
    return count;
  }, [routes, hasManifestPricing]);

  return (
    <div className="service-type-component">
      <div className={`wrap-box ${isSelectedService ? "selected-service" : ""}`}>
        <div className="first-content">
          {isSelectedService && (
            <h2 className="service-title-selected">⭐ Selected Route</h2>
          )}
          {service.logo && (
            <div style={{ textAlign: "center", marginBottom: "5px" }}>
              <img
                src={service.logo.url}
                alt={service.name}
                style={{
                  maxWidth: "100%",
                  height: "100px",
                  objectFit: "contain"
                }}
              />
            </div>
          )}
          {!service.logo && <div style={{ height: "100px", marginBottom: "5px" }} />}
          <div
            className="service-title"
            style={{ marginTop: "5px", marginBottom: "6px" }}
          >
            {service.name}
          </div>
          <div className="service-description" style={{ marginBottom: "8px" }}>
            {service?.description}
          </div>
          {hasManifestPricing && dropoffsWithoutInternalOrderId > 0 && (
            <div
              style={{
                backgroundColor: "#fffbe6",
                border: "1px solid #ffe58f",
                borderRadius: "4px",
                padding: "8px 12px",
                marginTop: "8px",
                marginBottom: "8px",
                color: "#ad6800"
              }}
            >
              ⚠️ There {dropoffsWithoutInternalOrderId === 1 ? "is" : "are"}{" "}
              <strong>{dropoffsWithoutInternalOrderId}</strong> dropoff
              {dropoffsWithoutInternalOrderId === 1 ? "" : "s"} without Internal Order ID
            </div>
          )}
        </div>
        <SelectRoutes
          routes={routes}
          setRoutes={setRoutes}
          service={service}
          estimatePriceOrganization={estimatePriceOrganization}
          drivers={drivers}
          driversLoading={driversLoading}
        />
        {service.termsLink && (
          <div className="wrap-return-pickup">
            <div className="terms-conditions text-center">
              <a href={service.termsLink} rel="noreferrer" target="_blank">
                Flexio Terms & Conditions
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceType;
